//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Debt from "./components/debt.vue";
import AccountPay from "./components/AccountPay.vue";
import ShortLoan from "./components/ShortLoan.vue";
import Profit from "./components/Profit.vue";
import CategoryProfit from "./components/CategoryProfit.vue";
export default {
  name: "Table",
  components: { Debt, AccountPay, ShortLoan, Profit, CategoryProfit },
  data() {
    return {
      loadingInstance: null,
      type: "",
      list: {
        debt: "资产负债表",
        "short-loan": "短期借款表",
        "account-pay": "应付账款表",
        profit: "利润表",
        "category-profit": "品类毛利率分析表",
      },
    };
  },
  created() {
    this.type = this.$route.query.type;
  },
  mounted() {
    this.loadingInstance = this.$loading({
      fullscreen: true,
      name: "wave",
      lock: true,
    });
  },
  destroyed() {
    this.loadingInstance.destroy();
  },
};
